import {
  BillingTerms,
  Direction,
  EquipmentType,
  Location,
  SharingEmailType,
} from '@rygen/rygen-ui/model';

export class DefaultOrderData {
  billingTerms?: BillingTerms;
  direction?: Direction;
  billToAddress?: Location;
  equipmentType?: EquipmentType;
  sharingEmailTypes?: SharingEmailType[];
  freightAllowanceEnabled: boolean = false;

  constructor(opts?: Partial<DefaultOrderData>) {
    if (opts?.billingTerms != null) {
      this.billingTerms = opts.billingTerms;
    }
    if (opts?.direction != null) {
      this.direction = opts.direction;
    }
    if (opts?.billToAddress != null) {
      this.billToAddress = opts.billToAddress;
    }
    if (opts?.equipmentType != null) {
      this.equipmentType = opts.equipmentType;
    }
    if (opts?.sharingEmailTypes != null) {
      this.sharingEmailTypes = opts.sharingEmailTypes;
    }
    if (opts?.freightAllowanceEnabled != null) {
      this.freightAllowanceEnabled = opts.freightAllowanceEnabled;
    }
  }
}
